// import ICMWrapper from "@/app/components/icm-wrapper";
import { FC, useEffect, useState } from "react";
import { Play } from "lucide-react";
import Image from "next/image";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { BULLION_PRODUCT } from "@/app/alts/bullion/type-constants";
import useMobile from "@/app/hooks/use-mobile";

const videoDataGold = [
    {
        title: "What is Digital Gold",
        img: "https://assets.incredmoney.com/images/png/video-thumbnail-bullion.png",
        /* "https://s3.ap-south-1.amazonaws.com/devblogs.incredmoney.com/blog/wp-content/uploads/2025/04/11112952/Listed-unlisted.webp" */ link: " https://youtube.com/shorts/QqRlahpajo8?feature=share",
    },
    {
        title: "How to invest in Digital Gold",
        img: "https://assets.incredmoney.com/images/png/video-thumbnail-bullion.png",
        /* "https://s3.ap-south-1.amazonaws.com/devblogs.incredmoney.com/blog/wp-content/uploads/2025/04/11112952/Listed-unlisted.webp" */ link: " https://youtube.com/shorts/lBVDJi3szkM?feature=share",
    },
    // {
    //     title: "Why pick a basket over a single share?",
    //     img: "https://assets.incredmoney.com/images/png/video-thumbnail-bullion.png",
    //     /* "https://s3.ap-south-1.amazonaws.com/devblogs.incredmoney.com/blog/wp-content/uploads/2025/04/11112952/Listed-unlisted.webp" */ link: "https://www.youtube.com/channel/UCtBQcrjFr_troh024-W4lXg",
    // },
];

const videoDataSilver = [
    {
        title: "What is Digital Silver",
        img: "https://assets.incredmoney.com/images/png/video-thumbnail-bullion.png",
        /* "https://s3.ap-south-1.amazonaws.com/devblogs.incredmoney.com/blog/wp-content/uploads/2025/04/11112952/Listed-unlisted.webp" */ link: "https://www.youtube.com/channel/UCtBQcrjFr_troh024-W4lXg",
    },
    {
        title: "How to invest in Digital Silver",
        img: "https://assets.incredmoney.com/images/png/video-thumbnail-bullion.png",
        /* "https://s3.ap-south-1.amazonaws.com/devblogs.incredmoney.com/blog/wp-content/uploads/2025/04/11112952/Listed-unlisted.webp" */ link: "https://www.youtube.com/channel/UCtBQcrjFr_troh024-W4lXg",
    },
    {
        title: "Why pick a basket over a single share?",
        img: "https://assets.incredmoney.com/images/png/video-thumbnail-bullion.png",
        /* "https://s3.ap-south-1.amazonaws.com/devblogs.incredmoney.com/blog/wp-content/uploads/2025/04/11112952/Listed-unlisted.webp" */ link: "https://www.youtube.com/channel/UCtBQcrjFr_troh024-W4lXg",
    },
];
interface Props {
    activeBullion: string;
    videoData?: videoData[];
    // children?: React.ReactNode;
    // [key: string]: any;
}
interface videoData {
    title: string;
    img: string;
    link: string;
}

const AllNeedToKnow: FC<Props> = ({ activeBullion }) => {
    const [videoData, setVideoData] = useState(videoDataGold);
    const [currIdx, setCurrIdx] = useState(0);
    const { isMobile } = useMobile();
    const autoPlay = videoData?.length > 2;
    const autoplayOptions = {
        delay: 3000,
        stopOnInteraction: false,
        playOnInit: autoPlay,
        stopOnMouseEnter: true,
    };

    useEffect(() => {
        console.log("currIdx: ", currIdx);
        // This effect can be used to perform any side effects when the active bullion changes

        if (activeBullion === BULLION_PRODUCT.GOLD.TYPE) {
            setVideoData(videoDataGold);
        } else if (activeBullion === BULLION_PRODUCT.SILVER.TYPE) {
            setVideoData(videoDataSilver);
        }
        // currIdx is only logged; do not re-run this when the carousel slides
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeBullion]);

    const plugins = [];
    plugins.push(Autoplay(autoplayOptions));

    const [emblaRef, emblaApi] = useEmblaCarousel(
        {
            align: "center",
            containScroll: "trimSnaps",
            loop: true,
        },
        plugins,
    );

    useEffect(() => {
        if (!emblaApi) return;
        const onSelect = () => setCurrIdx(emblaApi.selectedScrollSnap());
        emblaApi.on("select", onSelect);
        return () => {
            emblaApi.off("select", onSelect);
        };
    }, [emblaApi]);

    return (
        <div
            id="section-all-need-to-know"
            className="flex flex-col items-center py-[55px] md:py-s20"
        >
            <h2
                id="section-title"
                className="mb-8 px-6 text-3xl font-semibold leading-[130%] tracking-[-0.24px] text-neutral-900 md:text-6xl md:leading-[120%] md:tracking-[-0.48px]"
            >
                All you need to know
            </h2>
            {/* <ICMWrapper> */}

            <div
                ref={emblaRef}
                className={
                    "icm-container overflow-hidden px-6 md:px-0 " +
                    `${(isMobile && videoData?.length > 1) || autoPlay ? " w-full" : ""}`
                }
            >
                <div className="flex">
                    {videoData?.map((video: videoData, index: number) => {
                        return (
                            <div
                                id={"video-block-" + (index + 1)}
                                className="mx-[6px] flex min-w-[280px] items-center gap-s7 rounded-[16px] border border-neutralOpacityDark-10 p-s7 md:mx-[8px] md:min-w-[497px] md:gap-[21.32px] md:rounded-[21.3px] md:p-[21.3px]"
                                key={index}
                            >
                                <div
                                    id="video-img"
                                    className="mr-s7 flex w-[56px] min-w-[56px] items-center md:mr-0 md:min-w-[74px]"
                                >
                                    <Image
                                        width={74}
                                        height={74}
                                        className="h-[56px] min-w-[56px] cursor-pointer rounded-full bg-neutralOpacityDark-60 md:h-[74.6px] md:min-w-[74.6px]"
                                        src={video.img}
                                        priority
                                        alt={video.title}
                                        onClick={() => {
                                            if (typeof window != "undefined") {
                                                window.open(video.link);
                                            }
                                        }}
                                    />
                                    <Play
                                        id="video-play"
                                        className="relative right-[50px] cursor-pointer fill-white text-white"
                                    />
                                </div>
                                <p
                                    id="video-title"
                                    className="cursor-default select-none text-sm leading-[140%] md:text-[18.655px]"
                                >
                                    {video.title}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
            {/* </ICMWrapper> */}
        </div>
    );
};

export default AllNeedToKnow;
